

/**
 * Calculates the total retail cost for a property based on various transaction details
 * @param {Object} propertyData - Property data containing transaction details and characteristics
 * @returns {number} - The calculated total retail cost
 */
export const calculateTotalRetailCost =  (propertyData,fields =[]) => {
  // Fetch asset class details to get field configurations
 
  // Extract basic transaction values
  const currentTotalCost = propertyData?.transactionDetails?.totalCostOfPurchase;
  if(fields.length>0) return currentTotalCost;
  const currentSalePrice = propertyData?.transactionDetails?.salePrice;
  const retailSalePrice = propertyData?.transactionDetails?.retailBasePricePSF * (propertyData?.characteristics?.builtupArea ||
      propertyData?.characteristics?.tokenCalculationBase ||
      0);
  // Calculate initial total by replacing current sale price with retail sale price
  let total = currentTotalCost - currentSalePrice + retailSalePrice;

  // Handle LIVE status properties without asset class (typically land properties)
  if (propertyData?.status == "LIVE" && fields.length==0) {
    
   total=total -
      (propertyData?.transactionDetails?.gstINR || 0) +
      (retailSalePrice * (propertyData?.transactionDetails?.gst || 0)) / 100 -
      (propertyData?.transactionDetails?.stampDutyINR || 0) +
      (retailSalePrice * (propertyData?.transactionDetails?.stampDuty || 0)) /
        100
   
  }

  // Handle LIVE status properties with asset class (using dynamic field calculations)

  return total;
};

export const calculateTotalCost =  (
  propertyData,
  leadSalePricePSF,
  fields =[]
) => {

  if (leadSalePricePSF == 0) return calculateTotalRetailCost(propertyData,fields);
  const currentTotalCost =  propertyData?.transactionDetails?.totalCostOfPurchase;
  const currentSalePrice = propertyData?.transactionDetails?.salePrice;
  const retailSalePrice = propertyData?.transactionDetails?.retailBasePricePSF *
    (propertyData?.characteristics?.builtupArea ||
      propertyData?.characteristics?.tokenCalculationBase ||
      0);
  const leadSalePrice =
    (leadSalePricePSF || 0) *
    (propertyData?.characteristics?.builtupArea ||
      propertyData?.characteristics?.tokenCalculationBase ||
      0);
  // calculate total first ay subtracting old values and adding new salePrice
  let total ;
  if (fields.length>0) return currentTotalCost-retailSalePrice+ leadSalePrice;
  

  // if there is no assetClassId then its land and do old form
total = currentTotalCost - currentSalePrice + leadSalePrice;
  if (propertyData?.status == "LIVE" && fields.length==0)
    total=
      currentTotalCost -
      currentSalePrice +
      leadSalePrice -
      (propertyData?.transactionDetails?.gstINR || 0) +
      (retailSalePrice * (propertyData?.transactionDetails?.gst || 0)) / 100 -
      (propertyData?.transactionDetails?.stampDutyINR || 0) +
      (retailSalePrice * (propertyData?.transactionDetails?.stampDuty || 0)) /
        100
   

  // If fields exist, iterate through them to find fields with fieldLinkWith property
  // For each such field, get the percentage and INR value to subtract old INR and add new INR by calulating from percentage and add them in total
 
    
  // return total if the status is not live then we can return default value for perclosed without adding percentage
  return total;
};

export const calculateFraxValue = (tempTotalRetailCost, propertyData) => {
  const builtupArea = propertyData?.characteristics?.builtupArea;
  const tokenMultiplier = propertyData?.assetClass?.tokenMultiplier;
  const tokenCalculationBase =
    propertyData?.characteristics?.tokenCalculationBase;

  const denominator = builtupArea
    ? 144 * builtupArea
    : tokenMultiplier && tokenCalculationBase
    ? tokenMultiplier * tokenCalculationBase
    : 0;

  if (!denominator) return 0;

  return tempTotalRetailCost / denominator;
};
